import { WaterQuality } from '../../../types';

// 현재 시간 기준으로 임의 데이터 생성
const generateMockData = (count: number): WaterQuality[] => {
  const now = new Date();
  const data: WaterQuality[] = [];
  
  for (let i = 0; i < count; i++) {
    const timestamp = new Date(now.getTime() - (i * 60 * 60 * 1000)); // 매 시간 간격
    
    // 기본 값들에 약간의 변동을 주는 함수
    const fluctuate = (base: number, range: number) => base + (Math.random() * range * 2 - range);
    
    data.push({
      id: i + 1,
      pool_id: 1,
      ph: fluctuate(7.4, 0.4),                   // 7.0-7.8 (권장: 7.2-7.6)
      ph_level: Math.floor(Math.random() * 2),   // 0: normal, 1: warning
      chlorine: fluctuate(2, 1),                 // 1-3 ppm (권장: 1.5-2.5)
      chlorine_level: Math.floor(Math.random() * 2), // 0: normal, 1: warning
      temperature: fluctuate(28, 2),             // 26-30°C (권장: 27-29)
      turbidity: fluctuate(0.5, 0.3),            // 0.2-0.8 NTU (권장: <0.5)
      created_at: timestamp.toISOString(),
      updated_at: timestamp.toISOString()
    });
  }
  
  return data;
};

export const mockWaterQualityData = generateMockData(24); // 24시간 데이터 